/*
 * Fold German text for the shop search: lowercase, ß→ss, strip diacritics
 * (ä→a, é→e). Applied to needle and haystack, so "strasse" finds "Straße".
 */
export function normalizeSearchText(value) {
    return String(value ?? '')
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}
